<template>
	<div class="new-tool-form">
		<form>
			<div class="form-header">
				<section>
					<div class="tw-flex">
						<div class="number-process font-weight-bold tw-text-center text-white">
							1
						</div>
						<div class="ml-3 w-100">
							<h3 class="section-title font-weight-bold mb-3 pb-2"
								:style="`border-bottom:1px solid ${$appColors.gray}`"
							>NOMBRE DE COMITE</h3>
						</div>
					</div>
					<div class="code mt-3">
						<label for="new-tool-code"
							:style="`color:${$appColors.info}`"
						>
							Nombre de Comité
							<input
								id="new-tool-code"
								class="new-survey-input"
								placeholder="Código"
								v-model="newCommitee.name"
							/>
						</label>
					</div>
				</section>
			</div>
			<div class="form mt-4">
				<section class="general-section">
					<div class="tw-flex">
						<div class="number-process font-weight-bold tw-text-center text-white">
							2
						</div>
						<div class="ml-3">
							<h3 class="section-title font-weight-bold mb-3 pb-2"
								:style="`border-bottom:1px solid ${$appColors.gray}`"
							>SELECCIONAR PUESTOS A VALORAR</h3>
						</div>
					</div>
					<div class="label-commitees mb-2">
						Seleccionar las personas encargadas de valorar los puestos
					</div>
					<label :style="`color:${$appColors.primary};`">AGREGA PUESTOS</label>
					<div class="container-search mt-2">
						<label class="video-label"
							:style="`color:${$appColors.info}`"
						>
							Buscar Puestos
							<v-autocomplete
								dense
								class="autocomplete-select"
								background-color="white"
								box
								:height="37"
								append-icon="search"
								autocomplete
								return-object
								:items="stalls"
								item-text="name"
								item-value="id"
								v-model="newCommitee.job"
								hide-details
							></v-autocomplete>
						</label>
						<app-button
							:disabled="!newCommitee.job"
							class="video-btn ml-3"
							icon="add"
							@click="addJobs"
						/>
						<div class="video-link-container mt-2"
						v-for="(item, indexVi) in newCommitee.jobs"
						:key="indexVi">
							<div
								class="videos-link tw-flex tw-justify-between tw-items-center"
							>
								<div :style="`color:${$appColors.info}`">
									{{ item.name }}
								</div>
								<div>
									<app-tooltip-button
										img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg"
										text="Eliminar"
										@click-icon="deleteJobs(indexVi)"
									/>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section class="media-section ml-5">
					<div class="tw-flex">
						<div class="number-process font-weight-bold tw-text-center text-white">
							3
						</div>
						<div class="ml-3">
							<h3 class="section-title font-weight-bold mb-3 pb-2"
								:style="`border-bottom:1px solid ${$appColors.gray}`"
							>SELECCIONAR MIEMBROS DE COMITÉ</h3>
						</div>
					</div>
					<div class="label-commitees mb-2">
						Seleccionar las personas encargadas de valorar los puestos
					</div>
					<label :style="`color:${$appColors.primary};`" class="mt-2">AGREGAR MIEMBRO DE COMITÉ</label>
					<div class="container-search mt-2">
						<label class="video-label"
							:style="`color:${$appColors.info}`"
						>
							Buscar Encargados
							<v-autocomplete
								class="autocomplete-select"
								background-color="white"
								box
								hide-details
								append-icon="search"
								autocomplete
								return-object
								:items="members"
								item-text="name"
								item-value="id"
								v-model="newCommitee.employee"
							></v-autocomplete>
						</label>
						<app-button
							:disabled="!newCommitee.employee"
							class="video-btn ml-3"
							icon="add"
							@click="addEmployees"
						/>
						<div class="video-link-container mt-2"
						v-for="(item, indexVi) in newCommitee.stalls"
						:key="indexVi"
						>
							<div
								class="videos-link tw-flex tw-justify-between tw-items-center"
							>
								<span :style="`color:${$appColors.info}`">
									{{ item.name }}
								</span>
									<app-tooltip-button
										img="https://s3.amazonaws.com/apprunn-acl/COM-PRU-01/ARQ88/image/delete-button-(1).svg"
										text="Eliminar"
										@click-icon="deleteStalls(indexVi)"
									/>
							</div>
						</div>
					</div>
				</section>
			</div>
		</form>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				cancel-text="Atras"
				success-color="primary"
				success-text="Guardar"
				@cancel-button-clicked="goBack"
				@accept-button-clicked="createCommitee"
			></modal-sidebar-button>
		</section>
	</div>
</template>

<script>
	import appButton from '@/components/shared/app-button';

	function created() {
		const { id } = this.$route.params;
		this.idCommitee = id;
		if (id) {
			this.loadEditCommitee(id);
		}
		this.loadStalls();
		this.loadEmployees();
	}

	async function loadEditCommitee(id) {
		const response = await this.$httpPraktiko.get(`groups/${id}`);
		const { name, stalls, jobs } = response.data;
		this.newCommitee.name = name;
		this.newCommitee.stalls = stalls;
		this.newCommitee.jobs = jobs;
	}

	async function loadStalls() {
		const params = {
			typeGroup: 2,
		};
		const response = await this.$httpPraktiko.get('groups', { params });
		this.stalls = response.data;
	}

	async function loadEmployees() {
		const { data: response } = await this.$httpPraktiko.get('employee');
		this.members = response;
	}

	function formTitle() {
		return this.idCommitee ? 'Editar Comité' : this.$route.meta.title;
	}

	async function createCommitee() {
		const body = {
			name: this.newCommitee.name,
			code: this.newCommitee.name.replace(/ /g, '-'),
			jobs: this.newCommitee.jobs.map(p => p.id),
			employees: this.newCommitee.stalls.map(q => q.id),
		};
		try {
			await this.$httpPraktiko.post('groups', body);
			this.showNotification('El comité se creó correctamente.');
			this.goTo('job-evaluation-processes-commitees');
		} catch (error) {
			this.showGenericError();
		}
	}

	function flagEdit(flag) {
		if (flag) {
			this.newCommitee = { ...this.editingData };
		}
	}

	function addEmployees() {
		const { name, id } = this.newCommitee.employee;
		this.newCommitee.stalls.push({ name, id });
		this.newCommitee.employee = null;
	}

	function addJobs() {
		const { name, id } = this.newCommitee.job;
		this.newCommitee.jobs.push({ name, id });
		this.newCommitee.job = null;
	}

	function goBack() {
		this.$router.back();
	}

	function deleteStalls(index) {
		this.newCommitee.stalls.splice(index, 1);
	}

	function deleteJobs(index) {
		this.newCommitee.jobs.splice(index, 1);
	}

	function data() {
		return {
			idCommitee: null,
			members: [],
			newCommitee: {
				name: '',
				job: null,
				stalls: [],
				jobs: [],
			},
			stalls: [],
		};
	}

	export default {
		name: 'new-form-commitees',
		created,
		components: {
			appButton,
		},
		computed: {
			formTitle,
		},
		methods: {
			addEmployees,
			addJobs,
			createCommitee,
			deleteJobs,
			deleteStalls,
			goBack,
			loadEditCommitee,
			loadEmployees,
			loadStalls,
		},
		watch: {
			flagEdit,
		},
		data,
	};
</script>

<style lang="scss" scoped>
.new-tool-form {
	background-color: white;
	border: 1px solid #e9e9e9;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.2);
	margin-bottom: 21px;
	padding: 44px 0;

	.new-tool-form-title {
		font-family: font(bold);
		font-size: size(xlarge);
		margin-bottom: 22px;
		padding: 0 33px 12px;
	}

	label {
		font-size: size(small);

		input::placeholder {
			font-size: size(medium);
		}
	}

	.form {
		align-items: flex-start;
		display: flex;
		padding: 0 38px;

		.general-section, .media-section {
			flex-basis: 50%;
			// padding: 0 10px;
		}

		.w-100 {
			width: 100% !important;
		}
	}
}

.form-header {
	padding: 0 38px;
}

.number-process {
	background-color: #55ac4b;
	border-radius: 50%;
	height: 33px;
	font-size: 18px;
	padding-top: 2px;
	width: 33px;
}

.w-100 {
	width: 100%;
}

.container-search {
	align-items: flex-end;
	display: flex;
	flex-wrap: wrap;
}

.video-label {
	flex-basis: 89%;
}

.section-title {
	color: #545a54;
}

.img-link-container, .video-link-container {
	align-items: center;
	border: 1px solid #cdcdcd;
	padding: 0 15px 0 26px;
	width: 100%;
}

.video-btn {
	border-radius: 3px !important;
	height: 25px !important;
	width: 25px;
}

.label-commitees {
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
	font-size: 12px;
	padding: 9px 21px;
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/commitees/new-form-commitees.vue